import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { IonicModule, ModalController } from '@ionic/angular';
import { TankService } from '../../services/tank/tank.service';
import { Tank } from '../../models/tank';

/**
 * Standalone modal component for adding a new tank.
 * Can be opened programmatically via ModalController.
 */
@Component({
  selector: 'app-add-tank-modal',
  templateUrl: './add-tank-modal.component.html',
  styleUrls: ['./add-tank-modal.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule, ReactiveFormsModule],
})
export class AddTankModalComponent {
  private formBuilder = inject(FormBuilder);
  private tankService = inject(TankService);
  private modalController = inject(ModalController);

  /** Whether this modal is being shown as part of onboarding flow */
  @Input() isOnboarding = false;

  public tankFormDetails = this.formBuilder.group({
    name: ['', Validators.required],
    gallons: [0, [Validators.required, Validators.min(1)]],
  });

  get title(): string {
    return this.isOnboarding ? 'Set Up Your First Tank' : 'Add New Tank';
  }

  get subtitle(): string {
    return this.isOnboarding
      ? 'Give your tank a name and size to start tracking'
      : '';
  }

  cancel() {
    this.modalController.dismiss(null, 'cancel');
  }

  async confirm() {
    if (this.tankFormDetails.valid) {
      const tank: Tank = {
        name: this.tankFormDetails.value.name || '',
        gallons: this.tankFormDetails.value.gallons || 0,
      };

      await this.tankService.add(tank);
      this.modalController.dismiss(tank, 'confirm');
    }
  }
}

